import { useState, useEffect } from "react";
import { Menu, X, Globe } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Navigation = ({ t, lang, changeLang }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  const toggleLang = () => {
    changeLang(lang === "pt" ? "en" : "pt");
  };

  return (
    <nav
      data-testid="navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? "glass-card py-4" : "bg-transparent py-6"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between">
          <a
            href="#"
            data-testid="nav-logo"
            className="text-xl md:text-2xl font-medium tracking-tight transition-opacity hover:opacity-80"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            <span className="text-[#E5E5E5]">The</span>{" "}
            <span className="text-gold-gradient">Medical</span>{" "}
            <span className="text-[#E5E5E5]">Architect</span>
          </a>

          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection("#servicos")} className="text-sm tracking-widest uppercase text-[#A3A3A3] hover:text-[#C5A059] transition-colors duration-300">
              {t.nav.services}
            </button>
            <button onClick={() => scrollToSection("#portfolio")} className="text-sm tracking-widest uppercase text-[#A3A3A3] hover:text-[#C5A059] transition-colors duration-300">
              {t.nav.portfolio}
            </button>
            <button onClick={() => scrollToSection("#porquenosso")} className="text-sm tracking-widest uppercase text-[#A3A3A3] hover:text-[#C5A059] transition-colors duration-300">
              {t.nav.whyUs}
            </button>
            <button onClick={() => scrollToSection("#precos")} className="text-sm tracking-widest uppercase text-[#A3A3A3] hover:text-[#C5A059] transition-colors duration-300">
              {t.nav.pricing}
            </button>
            <button onClick={() => scrollToSection("#contacto")} className="text-sm tracking-widest uppercase text-[#A3A3A3] hover:text-[#C5A059] transition-colors duration-300">
              {t.nav.contact}
            </button>
            
            <button
              onClick={toggleLang}
              data-testid="lang-switcher"
              className="flex items-center gap-1.5 px-3 py-1.5 border border-white/10 hover:border-[#C5A059]/30 text-[#A3A3A3] hover:text-[#C5A059] transition-all duration-300"
            >
              <Globe className="w-3.5 h-3.5" />
              <span className="text-xs tracking-widest uppercase font-medium">{lang === "pt" ? "EN" : "PT"}</span>
            </button>
            
            <Button
              onClick={() => scrollToSection("#contacto")}
              data-testid="nav-cta-button"
              className="btn-gold bg-[#C5A059] text-[#050505] hover:bg-[#D4B068] px-6 py-2 text-sm tracking-widest uppercase font-medium"
            >
              {t.nav.cta}
            </Button>
          </div>

          <div className="flex items-center gap-3 md:hidden">
            <button
              onClick={toggleLang}
              data-testid="lang-switcher-mobile"
              className="flex items-center gap-1 px-2 py-1 border border-white/10 text-[#A3A3A3] hover:text-[#C5A059] transition-colors"
            >
              <Globe className="w-3.5 h-3.5" />
              <span className="text-xs tracking-widest uppercase">{lang === "pt" ? "EN" : "PT"}</span>
            </button>
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              data-testid="mobile-menu-toggle"
              className="text-[#E5E5E5] hover:text-[#C5A059] transition-colors"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden mt-6 pb-6 border-t border-white/10 pt-6 animate-fade-in">
            <div className="flex flex-col gap-4">
              <button onClick={() => scrollToSection("#servicos")} className="text-sm tracking-widest uppercase text-[#A3A3A3] hover:text-[#C5A059] transition-colors duration-300 text-left">
                {t.nav.services}
              </button>
              <button onClick={() => scrollToSection("#portfolio")} className="text-sm tracking-widest uppercase text-[#A3A3A3] hover:text-[#C5A059] transition-colors duration-300 text-left">
                {t.nav.portfolio}
              </button>
              <button onClick={() => scrollToSection("#porquenosso")} className="text-sm tracking-widest uppercase text-[#A3A3A3] hover:text-[#C5A059] transition-colors duration-300 text-left">
                {t.nav.whyUs}
              </button>
              <button onClick={() => scrollToSection("#precos")} className="text-sm tracking-widest uppercase text-[#A3A3A3] hover:text-[#C5A059] transition-colors duration-300 text-left">
                {t.nav.pricing}
              </button>
              <button onClick={() => scrollToSection("#contacto")} className="text-sm tracking-widest uppercase text-[#A3A3A3] hover:text-[#C5A059] transition-colors duration-300 text-left">
                {t.nav.contact}
              </button>
              <Button
                onClick={() => scrollToSection("#contacto")}
                className="btn-gold bg-[#C5A059] text-[#050505] hover:bg-[#D4B068] mt-4 text-sm tracking-widest uppercase font-medium"
              >
                {t.nav.cta}
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
